import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Cell,
  LabelList,
} from 'recharts';

const ProjectSummary = ({ projects = [] }) => {
  const { t } = useTranslation();
  console.log('📊 ProjectSummary received projects:', projects);
  console.log('📊 ProjectSummary projects length:', projects.length);
  
  // Define colors using translation keys
  const COLORS = {
    [t('projectSummary.notStarted')]: '#9CA3AF', // gray
    [t('projectSummary.onTrack')]: '#FACC15', // yellow
    [t('projectSummary.atRisk')]: '#EF4444', // red
    [t('projectSummary.completed')]: '#22C55E' // green
  };
  
  const counts = {
    [t('projectSummary.onTrack')]: 0,
    [t('projectSummary.atRisk')]: 0,
    [t('projectSummary.completed')]: 0,
    [t('projectSummary.notStarted')]: 0,
  };

  projects.forEach(project => {
    let status = project.status || 'Not Started';
    
    console.log(`📊 Processing project "${project.name}":`, {
      originalStatus: project.status,
      normalizedStatus: status,
      percentCompleted: project.percentCompleted
    });
    
    // Normalize status values to match expected format
    if (status.toLowerCase() === 'completed') {
      status = t('projectSummary.completed');
    } else if (status === 'On Track') {
      status = t('projectSummary.onTrack');
    } else if (status === 'At Risk') {
      status = t('projectSummary.atRisk');
    } else if (status === 'Not Started') {
      status = t('projectSummary.notStarted');
    } else {
      // Default to 'Not Started' for unknown statuses
      status = t('projectSummary.notStarted');
    }
    
    counts[status] += 1;
    console.log(`📊 Count for ${status}: ${counts[status]}`);
  });

  const statusCounts = Object.entries(counts).map(([name, value]) => ({ name, value }));
  console.log('📊 Final status counts:', statusCounts);

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={statusCounts}>
        <XAxis dataKey="name" stroke="#173861" tick={{ fontWeight: 600, fontSize: 14 }} />
        <Tooltip wrapperClassName="!rounded-lg !shadow-lg !border !border-gray-200"/>
        <Bar dataKey="value" radius={[8,8,0,0]} barSize={36}>
          <LabelList dataKey="value" position="top" style={{ fontWeight: 700, fill: '#173861' }} />
          {statusCounts.map((entry, index) => (
            <Cell key={index} fill={COLORS[entry.name]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ProjectSummary;